import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classnames from 'classnames';
import React__default from 'react';

var Divider = function Divider(_ref) {
  var className = _ref.className,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 1 : _ref$width,
    dataTestId = _ref['data-testid'];
  var finalClasses = classnames('C-Divider', _defineProperty({}, "--".concat(direction), direction), className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: finalClasses,
    "data-testid": dataTestId,
    role: "separator"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "C-Divider__line",
    style: direction === 'vertical' ? {
      width: width
    } : {
      height: width
    }
  }));
};
Divider.displayName = 'Divider';

export { Divider as default };
